module.exports = __webpack_public_path__ + "img/350.9f23b5cd.jpg";